import { apiClient } from './api/client';

import { ENDPOINTS } from './api/endpoints';

import type { Conversation, CreateConversationRequest, ChatMessage } from '@/types';



/** Matches GET `/api/conversations/{id}` JSON body subset we need for messages */

interface ConversationDetailApi {

  id: string;

  title: string | null;

  messages: Array<{

    id: string;

    type: string;

    content: string;

    timestamp: string;

    isError?: boolean;

    hasImage?: boolean;

    imageData?: string;

  }>;

}



export interface AddConversationMessagePayload {

  type: 'user' | 'assistant' | 'system';

  content: string;

  isError?: boolean;

  image_data?: string | null;

  has_image?: boolean;

}



function normalizeMessageType(raw: string): ChatMessage['type'] {

  if (raw === 'assistant' || raw === 'system' || raw === 'user') {

    return raw;

  }

  return 'user';

}



function mapConversationMessageRow(conversationId: string, row: ConversationDetailApi['messages'][0]): ChatMessage {

  return {

    id: row.id,

    conversationId,

    type: normalizeMessageType(row.type),

    content: row.content,

    createdAt: row.timestamp,

    isError: Boolean(row.isError),

    hasImage: Boolean(row.hasImage),

    imageData: row.imageData,

  };

}



export const conversationsService = {

  async getAll(): Promise<Conversation[]> {

    return apiClient.get<Conversation[]>(ENDPOINTS.CONVERSATIONS);

  },



  async getById(id: string): Promise<Conversation> {

    return apiClient.get<Conversation>(ENDPOINTS.CONVERSATION_DETAIL(id));

  },



  async create(data: CreateConversationRequest): Promise<Conversation> {

    return apiClient.post<Conversation>(ENDPOINTS.CONVERSATIONS, data);

  },



  async delete(id: string): Promise<void> {

    return apiClient.delete<void>(ENDPOINTS.CONVERSATION_DETAIL(id));

  },



  async getMessages(conversationId: string): Promise<ChatMessage[]> {

    const detail = await apiClient.get<ConversationDetailApi>(ENDPOINTS.CONVERSATION_DETAIL(conversationId));

    return (detail.messages ?? []).map((m) => mapConversationMessageRow(conversationId, m));

  },



  async addMessage(

    conversationId: string,

    payload: Omit<AddConversationMessagePayload, 'image_data' | 'has_image'> & {

      image_data?: string | null;

      has_image?: boolean;

    }

  ): Promise<unknown> {

    const body = {

      type: payload.type,

      content: payload.content,

      isError: payload.isError ?? false,

      image_data: payload.image_data,

      has_image: payload.has_image ?? false,

    };

    return apiClient.post<unknown>(ENDPOINTS.CONVERSATION_MESSAGES(conversationId), body);

  },

};

